import { PHOTO_HINDCAST } from "../constants"

class HindcastElement {
  constructor(element, location, token) {
    this.element = element
    this.location = location
    this.token = token
  }

  static fromHtmlElement(htmlElement, location, token) {
    const element = htmlElement.querySelector(PHOTO_HINDCAST)
    return element ? new HindcastElement(element, location, token) : null
  }

  async apply(photo) {
    if (!this.element || !photo.timestamp) {
      // Hide hindcast if no timestamp
      if (this.element) {
        this.element.style.display = "none"
      }
      return
    }

    try {
      const url = `/photos/${photo.id}/hindcast?location=${encodeURIComponent(this.location)}`
      const response = await fetch(url, {
        headers: {
          Accept: "text/html",
          "X-Requested-With": "XMLHttpRequest",
          "X-CSRF-Token": this.token,
        },
      })

      if (response.ok) {
        const html = await response.text()
        if (html.trim()) {
          this.element.innerHTML = html
          this.element.style.display = ""
        } else {
          this.element.style.display = "none"
        }
      } else {
        this.element.style.display = "none"
      }
    } catch (error) {
      console.error("Error loading hindcast:", error)
      this.element.style.display = "none"
    }
  }
}

export default HindcastElement
